import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { ConditionResource } from "@exonn/js-sdk";

export const module: Module = {
  id: ResourceEnum.Condition,
  smallIcon: <i className="icon-15-conditions" />,
  bigIcon: <i className="icon-20-conditions" />,
  name: (t: TFunction) => t("moduleName.conditions"),

  tabs: {
    edit: {
      getTitle: (resource: ConditionResource) => resource.title,
    },
  },
};
